export default "__VITE_ASSET__Bl1zYLi1__"